import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

function SaleReturnIndex() {
    const history = useHistory();

    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, logout, token } = useAuth();
    const [searchQuery, setSearchQuery] = useState(""); // State for search query
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {

        fetchtableData();

    }, []);

    const fetchtableData = async () => {

        fetchData('ReturnApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching SaleReturn Details:', error);
            });

    };


    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const handleCreateNewClick = (page) => {
        history.push(`/${page}`);
    };
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const filteredData = data.filter(item =>
        item.CustomerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.ReturnDate && new Date(item.ReturnDate).toLocaleDateString('en-GB').includes(searchQuery.toLowerCase()) ||
        item.RQty.toString().includes(searchQuery.toLowerCase()) ||
        item.TotalAmount.toString().includes(searchQuery.toLowerCase())
    );

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const SearchfilteredData = filteredData.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );
    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">

            <div className='w-full mb-2 flex'>
                <h6 className="uppercase tracking-wide text-black flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontSize: '16px' }}>Sale Return</h6>
                <div className="mt-2 md:mt-0 flex justify-center md:justify-end items-center">
                    <SearchIcon
                        onClick={toggleSearchInput}
                        style={{ cursor: 'pointer' }}
                    />
                    {showSearchInput && (
                        <input
                            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline ml-2 mt-2 md:mt-0 md:ml-3 w-3/4 md:w-48"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    )}
                </div>
                {hasCreateTransactionPermission && (

                    <Tooltip title="Create Sale return">
                        <Link to="/SaleReturnCreate" className="inline-block">
                            <Button
                                style={{
                                    background: 'linear-gradient(to right, darkslategray, slategray)',
                                    borderRadius: '50px',
                                    padding: '10px 20px',
                                    color: 'white',
                                    fontWeight: 'bolder',
                                    textTransform: 'none',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                    maxHeight: '35px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <AddIcon style={{ fontWeight: 'bolder' }} /> Create
                            </Button>
                        </Link>
                    </Tooltip>
                )}
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>

                <TableContainer component={Paper} style={{ maxHeight: '500px' }}>
                    <Table>
                        <TableHead sx={{ backgroundColor: '#008080' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontSize: '14px', padding: '4px' }}>Route</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontSize: '14px', padding: '4px' }}>Customer</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontSize: '14px', padding: '4px' }}>Return Date</TableCell>
                                <Tooltip title="Sale Return Bill Number">
                                    <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontSize: '14px', padding: '4px' }}> Return Bill No</TableCell>
                                </Tooltip>

                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', color: 'whitesmoke', fontSize: '14px', textAlign: 'right' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: 'rgba(38, 166, 154, 0.3)' }}>
                            {SearchfilteredData.map(item => (
                                <TableRow key={item.Id} className={item.IsActive ? 'activeRow' : 'inactiveRow'}>
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', width: '25px',fontSize:'12px' }}>{item.Route}</TableCell>
                                    {/* <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '5px', width: '25px' }}>{item.CustomerName} {item.AddressLine1} {item.CustomerCode}</TableCell> */}
                                    <TableCell
                                        style={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', width: '25px',fontSize:'12px' }}
                                    >
                                        {`${item.CustomerName} ${item.AddressLine1} ${item.CustomerCode}`}
                                    </TableCell>

                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', width: '25px' ,fontSize:'12px'}}>{item.ReturnDate && new Date(item.ReturnDate).toLocaleDateString('en-GB')}</TableCell>
                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', width: '25px' ,fontSize:'12px'}}>{item.ReturnNo}</TableCell>

                                    <TableCell style={{ borderBottom: '1px solid #F5F5F5', color: 'black', padding: '3px', textAlign: 'right', width: '25px' }}>
                                        {hasEditTransactionPermission && (
                                            <Link to={`/SaleReturnEdit/${item.Id}`}>
                                                <Tooltip title="Sale Return Edit">
                                                    <IconButton>
                                                        <EditIcon style={{ color: 'darkgoldenrod', fontSize: '20px' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Link>

                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}
export default SaleReturnIndex;

